import { pledgeApi, type PledgeFrontDTO, queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const usePledgeCreateQuery = () => {
	return useMutation({
		mutationFn: async ({ campaignId, pledge }: { campaignId: string; pledge: PledgeFrontDTO }) => {
			if (!campaignId) {
				throw new Error('Campaign ID is required');
			}

			return await (await pledgeApi).postPledgeCampaignPledgeByCampaign(campaignId, pledge);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['user-pledge-activity-summary'] });
		}
	});
};
